import {
  InheritedSettingValue,
  GroupedSettings,
  IDeliveryCutoffSetting,
  IDeliveryWeekLeadTimesSetting,
  IOrderModeSetting,
  IMinimumOrderValueSetting,
  IMinimumOrderQuantitySetting,
  IDeliveryRoute,
  IOrderDataRequired
} from "../api/drops.api";

/**
 * Gets the delivery cutoff from branch settings
 *
 * @param {GroupedSettings} settings
 * @returns {{ time: string }}
 */
export const getDeliveryCutoff = (groupedSettings: GroupedSettings): IDeliveryCutoffSetting | undefined => {
  if (groupedSettings) {
    if (groupedSettings.delivery_cutoff) {
      return groupedSettings.delivery_cutoff.value;
    }
  }

  return undefined;
};

/**
 * Gets the delivery week lead times settings
 *
 * @param {GroupedSettings} settings
 * @returns {{ time: string }}
 */
export const getDeliveryWeekLeadTimes = (groupedSettings?: GroupedSettings): IDeliveryWeekLeadTimesSetting | undefined => {
  if (groupedSettings) {
    if (groupedSettings.delivery_week_leadtimes) {
      // @ts-ignore - we know { time: string } is correct
      return groupedSettings.delivery_week_leadtimes.value;
    }
  }

  return undefined;
};

/**
 * Gets the minimum order value from branch settings
 *
 * @param {GroupedSettings} settings
 * @returns {{ value: number }
 */
export const getMinimumOrderValue = (groupedSettings: GroupedSettings): IMinimumOrderValueSetting | undefined => {
  if (groupedSettings) {
    if (groupedSettings.minimum_order_value) {
      return groupedSettings.minimum_order_value.value;
    }
  }

  return undefined;
};

/**
 * Gets the minimum order value from branch settings
 *
 * @param {GroupedSettings} settings
 * @returns {{ value: number }
 */
export const getOrderMode = (settings: GroupedSettings): IOrderModeSetting | undefined => {
  if (settings) {
    if (settings.order_mode) {
      return settings.order_mode.value;
    }
  }

  return undefined;
};

/**
 * Gets the minimum order quantity from branch settings
 *
 * @param {GroupedSettings} settings
 * @returns {{ quantity: number }}
 */
export const getMinimumOrderQuantitySetting = (groupedSettings: GroupedSettings): IMinimumOrderQuantitySetting | undefined => {
  if (groupedSettings) {
    if (groupedSettings.minimum_order_quantity) {
      return groupedSettings.minimum_order_quantity.value;
    }
  }

  return undefined;
};

/**
 * Gets the available delivery days from settings
 *
 * @param {GroupedSettings} settings
 * @returns {{ days: Array<number> }}
 */
export const getDeliveryRoute = (groupedSettings: GroupedSettings): IDeliveryRoute | undefined => {
  if (groupedSettings) {
    if (groupedSettings.delivery_route && groupedSettings.delivery_route.deliveryRoute) {
      return groupedSettings.delivery_route.deliveryRoute;
    }
  }

  return undefined;
};

/**
 * Gets the available delivery days from settings
 *
 * @param {GroupedSettings} settings
 * @returns {{ days: Array<number> }}
 */
export const getSingleOrder = (settings: GroupedSettings): { value: boolean } | undefined => {
  if (settings) {
    if (settings.one_daily_delivery) {
      return settings.one_daily_delivery.value;
    }
  }

  return undefined;
};

/**
 * Gets the delivery cutoff from branch settings
 *
 * @param {GroupedSettings} settings
 * @returns {{ time: string }}
 */
export const getOrderDataRequired = (groupedSettings: GroupedSettings): IOrderDataRequired | undefined => {
  if (groupedSettings) {
    if (groupedSettings.order_data_requirements) {
      return groupedSettings.order_data_requirements.value;
    }
  }

  return undefined;
};

/**
 * Gets the payment method required setting
 *
 * @param {GroupedSettings} settings
 * @returns {{ time: string }}
 */
export const getPaymentRequired = (groupedSettings: GroupedSettings): InheritedSettingValue["require_payment_method"] | undefined => {
  if (groupedSettings) {
    if (groupedSettings.order_data_requirements) {
      return groupedSettings.require_payment_method?.value;
    }
  }

  return undefined;
};

/**
 * Gets the payment method required setting
 *
 * @param {GroupedSettings} settings
 * @returns { allowed: boolean, userGroupIds: number[];}
 */
export const getAllowOrderCustomerComments = (groupedSettings: GroupedSettings): InheritedSettingValue["allow_order_customer_comments"] | undefined => {
  if (groupedSettings) {
    if (groupedSettings.allow_order_customer_comments) {
      return groupedSettings.allow_order_customer_comments?.value;
    }
  }

  return undefined;
};
